import Table from "components/data/Table";
import { FormattedMessage } from "react-intl";
import Header from "components/layout/Header";
import ButtonLink from "components/common/ButtonLink";
import { ROUTE_PATHS } from "const/paths";
import { Col, Typography } from "antd";

import { useTicketTemplateColumns, useTicketTemplateList } from "./hooks";

const TicketTemplateList: React.FC = () => {
  const columns = useTicketTemplateColumns();
  const ticketTemplateList = useTicketTemplateList();

  return (
    <>
      <Header>
        <Col>
          <Typography.Title>
            <FormattedMessage defaultMessage="Ticket Templates" />
          </Typography.Title>
        </Col>
        <Col>
          <ButtonLink type="primary" to={ROUTE_PATHS.TicketTemplateCreate}>
            <FormattedMessage defaultMessage="Add new Ticket Template" />
          </ButtonLink>
        </Col>
      </Header>
      <Table rowKey="id" columns={columns} {...ticketTemplateList} />
    </>
  );
};

export default TicketTemplateList;
